import React from "react";
import './CommonTip.css';

interface ICommonTipProps{

}

export const CommonTip = ({}: ICommonTipProps)=>{
    return <div className={`commonTip`}>
        <div className="commonTip_header">
            New tips are available!
        </div>
        <div className="commonTip_text">
            We prepared a new tips based on your last session. Open a Transcription document to see it.
        </div>
        <div className="commonTip_buttons">
            <div className="button commonTip_button commonTip_button_primary">
                Open a Transcription
            </div>
            <div className="button commonTip_button commonTip_button_secondary">
                Later
            </div>
        </div>
    </div>
}